// extracted by mini-css-extract-plugin
export var box = "_4t-2";
export var checkboxControl = "_4t-0";
export var checkboxRow = "_4t-9";
export var checked = "_4t-3";
export var descriptionSpacer = "_4t-b";
export var disabled = "_4t-4";
export var icon = "_4t-7";
export var input = "_4t-1";
export var labelSpacer = "_4t-a";
export var medium = "_4t-6";
export var small = "_4t-5";
export var text = "_4t-8";